import { render, staticRenderFns } from "./clinicPlanSearchBar.vue?vue&type=template&id=474a8f8f&scoped=true"
import script from "./clinicPlanSearchBar.vue?vue&type=script&lang=js"
export * from "./clinicPlanSearchBar.vue?vue&type=script&lang=js"
import style0 from "./clinicPlanSearchBar.vue?vue&type=style&index=0&id=474a8f8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a8f8f",
  null
  
)

export default component.exports